import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { Book } from 'rebook/apps/books/models';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const BookAuthor = ({ book }) => {
  if (!book) {
    return;
  }

  const BookModel = new Book(book);

  const authorList = get(book, 'authors.length', 0) > 1
    ? get(BookModel, 'authors', null)
    : [(get(BookModel, 'main_author', null))];

  let authorListLinks;

  if (authorList && authorList.length > 2) {
    const author = authorList[0];

    const authorState = {
      pathname: author.absolute_url,
      state: { author },
    };

    const otherAuthorsCount = authorList.length - 1;

    authorListLinks = (
      <span key={author.id}>
        <Link to={authorState} className={styles.authorName}>
          {author.cover_name}
        </Link>
        <Link to={book.getAuthorsLink()} className={styles.authorName}>
          {' '}и еще {otherAuthorsCount} {pluralize(otherAuthorsCount, 'автор', 'автора', 'авторов')}
        </Link>
      </span>
    );
  }
  else {
    authorListLinks = authorList.map((author, index) => {
      const authorState = {
        pathname: author.absolute_url,
        state: { author },
      };

      return (
        <span key={author.id}>
          <Link to={authorState} className={styles.authorName}>
            {author.cover_name}
          </Link>
          {index < (authorList.length - 1) && ', '}
        </span>
      );
    });
  };


  const authorLink = authorList && authorList.length > 1
    ? {
      pathname: BookModel.getAuthorsUrl(),
      state: { book },
    }
    : {
      pathname: authorList[0].absolute_url,
      author: authorList[0],
    };

  return (
    <div className={styles.coverAuthor}>
      <div className={styles.authorList}>
        {authorListLinks}
      </div>
      <Link to={authorLink} className={styles.link}>
        <i className="shortArrowWhite" />
      </Link>
    </div>
  );
};

BookAuthor.propTypes = {
  book: PropTypes.shape({
    absolute_url: PropTypes.string.isRequired,
    authors: PropTypes.arrayOf(PropTypes.shape({
      absolute_url: PropTypes.string.isRequired,
      cover_name: PropTypes.string.isRequired,
    })).isRequired,
    main_author: PropTypes.shape({
      absolute_url: PropTypes.string.isRequired,
      cover_name: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default BookAuthor;
